// Takes a string and a payload type and creates an object with those types
// Only used as a pseudo type-return, payload is an empty object
export const action = <T>(type: T) => {
  const payload = <P>(p = {} as P): { type: T; payload: P } => ({
    type,
    payload: p,
  });
  return { payload };
};

export interface StatelessAction {
  type: string;
  payload: unknown;
}
